module.exports = __webpack_public_path__ + "img/3.39ffc088.gif";